export const getImageInfo = async (fullStorageKey) => {
  console.log('fullStorageKey', fullStorageKey);
  let response = await fetch(`${global.location.origin}/image-details?fullStorageKey=${fullStorageKey}`);
  response = await response.json();
  if (response.storageURL) {
    return response;
  }
  throw new Error(`Invalid storage key:${fullStorageKey} or bad response: ${JSON.stringify(response)}`);
};
